import EditablePersianSupportTextField from 'Global/Components/EditableComponents/EditablePersianSupportTextField';
import React from 'react';
import i18next from 'i18next';
import { Stack } from '@mui/material';
import ToggleButtonCreator from 'Global/Components/CommonComponents/ToggleButtonCreator/ToggleButtonCreator';
import { IconOptions } from '../../../variables/IconOptions';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import PicutreDropField from 'Global/Components/CommonComponents/PicutreDropField/PicutreDropField';
import HexColorSelector from 'Global/Components/CommonComponents/HexColorSelector/HexColorSelector';
import LanguageSelector from '../../LanguageSelector/LanguageSelector';
import EditableCustomCheckBox from 'Global/Components/EditableComponents/EditableCustomCheckBox.js/EditableCustomCheckBox';

const SettingElementCreator = ({
  field,
  index,
  languageSelector_msg,
  onChange,
  selectIconLabel,
  labelArray,
}) => {
  const createSettingElements = () => {
    if (
      [
        'webAppFaramoshiRamz',
        'webAppLoginByMobile',
      ].includes(field?.Key)
    ) {
      return (
        <div
          dir={i18next.language === 'en' ? 'ltr' : 'rtl'}
        >
          <EditableCustomCheckBox
            label={
              labelArray.find((el) => (el.key === field.Key))
                ?.value
            }
            defaultChecked={field.Value === 'True'}
            size="1.3em"
            BooleanOutPut
            onChange={(val) => {
              if (val) {
                onChange('True');
              } else {
                onChange('False');
              }
            }}
          />
        </div>
      );
    }
    if (
      [
        'webAppNameMarkaz',
        'webAppTelMarkaz',
        'webAppAddressMarkaz',
        'WebAppEnamadURL',
      ].includes(field?.Key)
    ) {
      return (
        <EditablePersianSupportTextField
          label={
            labelArray.find((el) => (el.key === field.Key))
              ?.value
          }
          isEnglish={i18next.language === 'en'}
          Initialvalue={field?.Value?.trim()}
          onChange={onChange}
        />
      );
    }

    if (field?.Key === 'webAppLogo') {
      return (
        <PicutreDropField
          placeholder={
            labelArray.find((el) => (el.key === field.Key))
              ?.value
          }
          UiValue={field?.Value}
          onChange={onChange}
        />
      );
    }

    if (
      ['webAppColorDefault', 'webAppColorOrg'].includes(
        field?.Key
      )
    ) {
      return (
        <HexColorSelector
          label={
            labelArray.find((el) => (el.key === field.Key))
              ?.value
          }
          onChange={onChange}
          UiValue={field?.Value}
        />
      );
    }

    if (field?.Key === 'webAppLangDefault') {
      return (
        <LanguageSelector
          onChange={onChange}
          languageSelector_msg={languageSelector_msg}
        />
      );
    }

    if (field?.Key === 'webAppIconType') {
      return (
        <Stack>
          <small
            style={{
              fontSize: '.9em',
            }}
          >
            {selectIconLabel}
          </small>
          <ToggleButtonCreator
            iconArray={IconOptions}
            defaultValue={Number(field?.Value)}
            onChange={onChange}
            sx={{
              marginTop: '0',
            }}
          />
        </Stack>
      );
    }
  };

  // console.log(
  //   'createSettingElements()--->',
  //   createSettingElements()
  // );

  return (
    <React.Fragment>
      {createSettingElements()}
    </React.Fragment>
  );
};

export default SettingElementCreator;
